var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.items),function(chip,index){return _c('a-tag',{key:`${chip}-${index}`,staticClass:"rounded",attrs:{"closable":""},on:{"close":function($event){$event.preventDefault();return _vm.remove(chip)}}},[_vm._v(_vm._s(_vm.chipValue(chip,chip.value)))])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }